// extracted by mini-css-extract-plugin
export default {"container":"Zp-z","ratingLayout":"_p-z","ratingLabel":"aq-z","nonInteractiveRatingLabel":"bq-z"};